<template>
  <div class="clearfix">
    <div>
      <VInputWrapper
        class="m-2"
        :label="trans('event.assessment_configs.field_types.students_per_timeslot')"
        name="students_per_timeslot"
        :required="true"
        :errors="getErrorsForField('config_data.students_per_timeslot')"
      >
        <input
          id="students_per_timeslot"
          v-model="studentsPerTimeslot"
          class="form-control"
          type="number"
          min="1"
          :disabled="viewOnly"
        >
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('event.assessment_configs.field_types.timeslot_count')"
        name="timeslot_count"
        :required="true"
        :errors="getErrorsForField('config_data.timeslot_count')"
      >
        <input
          id="timeslot_count"
          v-model="timeslotCount"
          class="form-control"
          type="number"
          min="1"
          :disabled="viewOnly"
        >
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('event.assessment_configs.field_types.minutes_per_timeslot')"
        name="minutes_per_timeslot"
        :required="true"
        :errors="getErrorsForField('config_data.minutes_per_timeslot')"
      >
        <input
          id="minutes_per_timeslot"
          v-model="minutesPerTimeslot"
          class="form-control"
          type="number"
          min="1"
          :disabled="viewOnly"
        >
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('event.assessment_configs.field_types.minutes_between_timeslots')"
        name="minutes_between_timeslots"
        :required="true"
        :errors="getErrorsForField('config_data.minutes_between_timeslots')"
      >
        <input
          id="minutes_between_timeslots"
          v-model="minutesBetweenTimeslots"
          class="form-control"
          type="number"
          min="1"
          :disabled="viewOnly"
        >
      </VInputWrapper>

      <VInputWrapper
        class="m-2"
        :label="trans('event.assessment_configs.field_types.timeslots_at_once')"
        name="timeslots_at_once"
        :required="true"
        :errors="getErrorsForField('config_data.timeslots_at_once')"
      >
        <input
          id="timeslots_at_once"
          v-model="timeslotsAtOnce"
          class="form-control"
          type="number"
          min="1"
          :disabled="viewOnly"
        >
      </VInputWrapper>
    </div>
    <button
      type="button"
      class="btn btn-primary float-right m-2"
      :disabled="isSaving"
      @click="saveSetupConfiguration()"
    >
      {{ trans('event.assessment_configs.plan_and_share') }}
    </button>
  </div>
</template>

<script>
import errorsMixin from '@/mixins/errorsMixin'
import { mapState } from 'vuex'
export default {
  name: 'AssessmentConfigSingleStudentView',
  mixins: [errorsMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      minutesPerTimeslot: 60,
      studentsPerTimeslot: 1,
      minutesBetweenTimeslots: 0,
      timeslotsAtOnce: 1,
      timeslotCount: this.event.students.length,
      viewOnly: false,
      isSaving: false,
    }
  },
  computed: {
    ...mapState({
      assessmentConfig (state) {
        return state.events.assessment_configs[this.event.assessmentConfig]
      },
    }),
  },
  created () {
    if (this.event.assessmentConfig) {
      this.minutesPerTimeslot = this.assessmentConfig.config_data.minutes_per_timeslot
      this.studentsPerTimeslot = this.assessmentConfig.config_data.students_per_timeslot
      this.minutesBetweenTimeslots = this.assessmentConfig.config_data.minutes_between_timeslots
      this.timeslotsAtOnce = this.assessmentConfig.config_data.timeslots_at_once
      this.timeslotCount = this.assessmentConfig.config_data.timeslot_count
      //* The assessment config can't be updated later on, once child events have being generated
      this.viewOnly = !!this.event.childEvents && this.event.childEvents.length !== 0
    } else {
      this.timeslotCount = this.event.students.length
    }
  },
  methods: {
    saveSetupConfiguration () {
      this.isSaving = true
      const assessmentConfigRequest = this.event.assessmentConfig != null
        ? this.updateAssessmentConfig()
        : this.createAssessmentConfig()

      assessmentConfigRequest
        .then(() => { this.nextStep() })
        .catch(error => { this.extractErrors(error)})
        .finally(() => {
            this.isSaving = false
          })
    },
    nextStep () {
      this.$emit('change-step')
    },
    getData () {
      return {
        minutes_per_timeslot: this.minutesPerTimeslot,
        students_per_timeslot: this.studentsPerTimeslot,
        minutes_between_timeslots: this.minutesBetweenTimeslots,
        timeslots_at_once: this.timeslotsAtOnce,
        timeslot_count: this.timeslotCount,
      }
    },
    createAssessmentConfig () {
      return this.$store.dispatch('createAssessmentConfig',
        {
          eventId: this.event.id,
          data: {
            config_type: 'single_student',
            config_data: this.getData(),
          },
        })
    },
    updateAssessmentConfig () {
      return this.$store.dispatch('updateAssessmentConfig',
        {
          assessmentConfigId: this.event.assessmentConfig,
          data: {
            config_type: 'single_student',
            config_data: this.getData(),
          },
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-primary {
  background-color: #25167a !important;
}
</style>
